import {
    clearScenesPendingAgent,
    markSceneBlurred,
    markScenesPendingAgent,
    markSceneTouchedByAgent,
} from './agent-activity-actions';

import type { AppDispatch } from 'js/src/libs/RootState';

/** Hold scenes under the agent-activity indicator, blurred, for the rest of the turn. */
export function markScenesBusy(dispatch: AppDispatch, sceneIds: string[]): void {
    if (sceneIds.length === 0) {
        return;
    }
    dispatch(markSceneBlurred({ sceneIds }));
    dispatch(markSceneTouchedByAgent({ sceneIds }));
}

export function markScenesPending(dispatch: AppDispatch, sceneIds: string[]): void {
    if (sceneIds.length === 0) {
        return;
    }
    dispatch(markScenesPendingAgent({ sceneIds }));
}

export function clearScenesPending(dispatch: AppDispatch, sceneIds: string[]): void {
    if (sceneIds.length === 0) {
        return;
    }
    dispatch(clearScenesPendingAgent({ sceneIds }));
}
